import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '../ui/sidebar';
import { useGameSwitch } from '@/hooks/useGameSandboxSwitch';
import { useGetGames } from '@/api/getGames';
import { ChevronsUpDown, Gamepad } from 'lucide-react';
import { useGame } from '@/hooks/useGame';
import { GameImage } from '../gameMiniature';
import { Link } from 'react-router-dom';
import { Game } from '@/models/game';

const GameLogo = ({ game }: { game: Game }) => {
  return (
    <div className="flex aspect-square size-8 items-center justify-center rounded-lg text-sidebar-primary-foreground">
      <GameImage game={game} />
    </div>
  );
};
export const GameSwitcher = () => {
  const isNonProduction = import.meta.env.MODE !== 'production';
  const game = useGame();

  const { data: gamesData } = useGetGames();

  const { switchGame } = useGameSwitch();

  const handleGameChange = (newGameCode: string) => {
    switchGame(game.game_code, newGameCode);
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-state-open:bg-sidebar-accent data-state-open:text-sidebar-accent-foreground"
            >
              <GameLogo game={game} />
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="flex items-center gap-2 font-medium">
                  Nacon Live
                  {isNonProduction && (
                    <span
                      className="data-[env=development]:text-cyan-300 data-[env=staging]:text-amber-300"
                      data-env={import.meta.env.MODE}
                    >
                      {import.meta.env.MODE === 'development'
                        ? 'Dev'
                        : 'Staging'}
                    </span>
                  )}
                </span>
                <span className="truncate text-xs text-sidebar-secondary-foreground">
                  {game.name}
                </span>
              </div>
              <ChevronsUpDown className="ml-auto" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="w-xs">
            <DropdownMenuRadioGroup
              value={game.game_code}
              onValueChange={handleGameChange}
              className="max-h-48 overflow-y-auto"
            >
              {gamesData?.games.map((game) => (
                <DropdownMenuRadioItem
                  key={game.game_code}
                  value={game.game_code}
                >
                  <GameLogo game={game} />
                  <span className="truncate text-sm font-medium">
                    {game.name}
                  </span>
                </DropdownMenuRadioItem>
              ))}
            </DropdownMenuRadioGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem>
              <Link to={`/game`} className="w-full">
                <div className="flex items-center gap-2">
                  <Gamepad className="size-4" />
                  <span>Games</span>
                </div>
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
